const createGroupData = data =>
  data.reduce((newPayload, dataItem) => {
    const { relationships, attributes } = dataItem
    const { title: name, value } = attributes
    const groupID = relationships.groups.data.id
    const currentGroupData = newPayload[groupID] || []
    return {
      ...newPayload,
      [groupID]: [...currentGroupData, { name, value }]
    }
  }, {})

const insertGroupDataIntoObject = (included, groupedData) =>
  included.map(currentGroup => {
    const { id, attributes, type } = currentGroup
    const { title, priority } = attributes
    const content = groupedData[id]
    return {
      id,
      type,
      title,
      content,
      attributes: { priority }
    }
  })

const removeUnwantedSpecifications = (specifications, specsToRemove) => {
  // NB: Modifies the original array
  const specsToRemoveLower = new Set(
    specsToRemove.map(title => {
      return title.toLowerCase()
    })
  )

  for (let index = specifications.length - 1; index >= 0; index -= 1) {
    if (specsToRemoveLower.has(specifications[index].title.toLowerCase())) {
      specifications.splice(index, 1)
    }
  }
}

const comparisonIconsString = 'comparison_icons'
const comparisonAttributesString = 'comparison_attributes'
const comparisonGroupsString = 'comparison_groups'

const sortByPriority = (first, second) => second.attributes.priority - first.attributes.priority
const byType = type => item => item.type === type

const byComparisonAttribute = byType(comparisonAttributesString)
const byComparisonIcon = byType(comparisonIconsString)
const byComparisonGroups = byType(comparisonGroupsString)

const createSortedIconArray = (listOfIcons, maxNumberOfIcons = 6, minNumberOfIcons = 4) => {
  if (listOfIcons.length < minNumberOfIcons) return []
  listOfIcons.sort(sortByPriority)
  return listOfIcons.slice(0, maxNumberOfIcons)
}

const transformSpecification = (payload, specsToRemove, maxNumberOfIcons, minNumberOfIcons) => {
  const comparisonAttributePayload = payload.filter(byComparisonAttribute)
  const comparisonIconPayload = payload.filter(byComparisonIcon)
  const comparisonGroupsPayload = payload.filter(byComparisonGroups)

  const groupedData = createGroupData(comparisonAttributePayload)
  const pictogramList = createSortedIconArray(comparisonIconPayload, maxNumberOfIcons, minNumberOfIcons)

  const specificationList = insertGroupDataIntoObject(comparisonGroupsPayload, groupedData)
  if (specsToRemove) {
    removeUnwantedSpecifications(specificationList, specsToRemove)
  }
  specificationList.sort(sortByPriority)

  return { pictogramList, specificationList }
}

export default transformSpecification
export {
  comparisonIconsString,
  comparisonAttributesString,
  comparisonGroupsString,
  transformSpecification,
  removeUnwantedSpecifications
}
